/* =========================================================================
   CAPRI BELLS — Shopify Theme · theme.js v2.0
   Animations + interactions · editorial luxury
   ========================================================================= */

(function () {
  'use strict';

  // ---------- Mobile menu ----------
  function initMobileMenu() {
    const toggles = document.querySelectorAll('[data-menu-toggle]');
    const closers = document.querySelectorAll('[data-menu-close]');
    const menu = document.getElementById('MobileMenu');
    if (!menu) return;

    function open() {
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      document.body.classList.add('menu-open');
    }
    function close() {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
    }
    toggles.forEach(btn => btn.addEventListener('click', open));
    closers.forEach(btn => btn.addEventListener('click', close));
  }

  // ---------- Countdown (multipli) ----------
  function initCountdowns() {
    const nodes = document.querySelectorAll('[data-countdown]');
    if (!nodes.length) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      nodes.forEach(node => {
        const deadline = node.getAttribute('data-deadline');
        if (!deadline) return;
        const end = new Date(deadline).getTime();
        const now = Date.now();
        let diff = end - now;

        if (diff <= 0) {
          node.classList.add('expired');
          const parent = node.closest('[data-countdown-wrapper]');
          if (parent) parent.style.display = 'none';
          const d = node.querySelector('[data-days]'); if (d) d.textContent = '00';
          const h = node.querySelector('[data-hours]'); if (h) h.textContent = '00';
          const m = node.querySelector('[data-minutes]'); if (m) m.textContent = '00';
          const s = node.querySelector('[data-seconds]'); if (s) s.textContent = '00';
          return;
        }

        const days = Math.floor(diff / 86400000); diff -= days * 86400000;
        const hours = Math.floor(diff / 3600000); diff -= hours * 3600000;
        const mins = Math.floor(diff / 60000); diff -= mins * 60000;
        const secs = Math.floor(diff / 1000);

        const d = node.querySelector('[data-days]'); if (d) d.textContent = pad(days);
        const h = node.querySelector('[data-hours]'); if (h) h.textContent = pad(hours);
        const m = node.querySelector('[data-minutes]'); if (m) m.textContent = pad(mins);
        const s = node.querySelector('[data-seconds]'); if (s) s.textContent = pad(secs);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  // ---------- Reveal on scroll ----------
  function initReveal() {
    const nodes = document.querySelectorAll('.reveal, .reveal-L, .reveal-R, .reveal-scale, .word-reveal');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(n => n.classList.add('visible'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    nodes.forEach(n => io.observe(n));
  }

  // ---------- Word-reveal: split text in words + chars (no word break) ----------
  function initWordReveal() {
    const blocks = document.querySelectorAll('[data-word-reveal]');
    blocks.forEach(block => {
      if (block.dataset.wordRevealDone === '1') return;
      const raw = block.textContent.trim();
      const words = raw.split(/\s+/);
      block.innerHTML = '';
      words.forEach((w, wi) => {
        const wordSpan = document.createElement('span');
        wordSpan.className = 'word';
        const chars = Array.from(w);
        chars.forEach((c, ci) => {
          const charSpan = document.createElement('span');
          charSpan.className = 'char';
          charSpan.textContent = c;
          const globalIdx = wi * 6 + ci;
          charSpan.style.transitionDelay = (globalIdx * 0.018) + 's';
          wordSpan.appendChild(charSpan);
        });
        block.appendChild(wordSpan);
        if (wi < words.length - 1) block.appendChild(document.createTextNode(' '));
      });
      block.dataset.wordRevealDone = '1';
      block.classList.add('word-reveal');
    });
  }

  // ---------- Parallax (data-parallax) ----------
  function initParallax() {
    const nodes = document.querySelectorAll('[data-parallax]');
    if (!nodes.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;
    function update() {
      const scrollY = window.scrollY;
      nodes.forEach(node => {
        const speed = parseFloat(node.getAttribute('data-parallax')) || 0.3;
        const rect = node.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const offset = scrollY * speed * -1;
        node.style.transform = 'translate3d(0,' + offset + 'px,0)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  // ---------- Hero canvas (particelle oro + glow orizzonte) ----------
  function initHeroCanvas() {
    const canvases = document.querySelectorAll('[data-hero-canvas]');
    if (!canvases.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    canvases.forEach(canvas => {
      const ctx = canvas.getContext('2d');
      let w, h, particles = [];
      const PARTICLE_COUNT = 36;

      function resize() {
        w = canvas.width = canvas.offsetWidth * window.devicePixelRatio;
        h = canvas.height = canvas.offsetHeight * window.devicePixelRatio;
      }
      resize();
      window.addEventListener('resize', resize, { passive: true });

      for (let i = 0; i < PARTICLE_COUNT; i++) {
        particles.push({
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 2 + 0.5,
          vx: (Math.random() - 0.5) * 0.15,
          vy: -Math.random() * 0.2 - 0.05,
          opacity: Math.random() * 0.4 + 0.2
        });
      }

      function frame() {
        ctx.clearRect(0, 0, w, h);

        // Glow orizzonte
        const horizonY = h * 0.72;
        const grad = ctx.createRadialGradient(w / 2, horizonY, 0, w / 2, horizonY, w * 0.5);
        grad.addColorStop(0, 'rgba(197, 165, 90, 0.14)');
        grad.addColorStop(1, 'rgba(197, 165, 90, 0)');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, w, h);

        // Particles
        particles.forEach(p => {
          p.x += p.vx;
          p.y += p.vy;
          if (p.y < -10) { p.y = h + 10; p.x = Math.random() * w; }
          if (p.x < -10) p.x = w + 10;
          if (p.x > w + 10) p.x = -10;

          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r * window.devicePixelRatio, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(217, 190, 122,' + p.opacity + ')';
          ctx.fill();
        });

        requestAnimationFrame(frame);
      }
      frame();
    });
  }

  // ---------- Cart forms (AJAX add) ----------
  function initCartForms() {
    const forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(form => {
      form.addEventListener('submit', async (e) => {
        if (form.hasAttribute('data-skip-ajax')) return;
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        if (btn) btn.setAttribute('disabled', 'true');

        try {
          const fd = new FormData(form);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: fd,
            headers: { 'Accept': 'application/javascript' }
          });
          if (!res.ok) throw new Error('add failed');
          await updateCartCount();
          if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        } catch (err) {
          console.error(err);
          form.submit();
        } finally {
          if (btn) btn.removeAttribute('disabled');
        }
      });
    });
  }

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.toggleAttribute('hidden', cart.item_count === 0);
      });
    } catch (e) { console.warn(e); }
  }

  // ---------- Variant pickers ----------
  function initVariantPickers() {
    document.querySelectorAll('[data-variant-radio]').forEach(radio => {
      radio.addEventListener('change', () => {
        const group = radio.closest('[data-variant-group]');
        if (!group) return;
        group.querySelectorAll('label[data-variant-label]').forEach(l => l.classList.remove('is-selected'));
        const parentLabel = radio.closest('label');
        if (parentLabel) parentLabel.classList.add('is-selected');
      });
    });
  }

  // ---------- Cart drawer ----------
  function initCartDrawer() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    window.openCartDrawer = () => {
      drawer.classList.add('open');
      document.body.classList.add('cart-open');
      renderCartDrawer();
    };
    window.closeCartDrawer = () => {
      drawer.classList.remove('open');
      document.body.classList.remove('cart-open');
    };

    document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', () => window.openCartDrawer()));
    document.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', () => window.closeCartDrawer()));
  }

  async function renderCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const container = document.querySelector('[data-cart-drawer]');
      if (container) {
        const subtotalEl = container.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = (cart.total_price / 100).toLocaleString('it-IT', { style: 'currency', currency: cart.currency || 'EUR' });
      }
    } catch (e) { console.warn(e); }
  }

  // ---------- Announcement bar close ----------
  function initAnnouncementBar() {
    const bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    const close = bar.querySelector('[data-announcement-close]');
    if (close) {
      close.addEventListener('click', () => {
        bar.style.display = 'none';
        try { sessionStorage.setItem('capri_bar_closed', '1'); } catch (e) {}
      });
    }
    try {
      if (sessionStorage.getItem('capri_bar_closed') === '1') bar.style.display = 'none';
    } catch (e) {}
  }

  // ---------- Ken Burns ----------
  function initKenBurns() {
    const nodes = document.querySelectorAll('[data-ken-burns]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(n => n.classList.add('kb-active'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('kb-active');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    nodes.forEach(n => io.observe(n));
  }

  // ---------- Scroll progress bar ----------
  function initScrollProgress() {
    const bar = document.querySelector('[data-scroll-progress]');
    if (!bar) return;

    let ticking = false;
    function update() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docH = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docH > 0 ? Math.min(1, Math.max(0, scrollTop / docH)) : 0;
      bar.style.width = (pct * 100).toFixed(2) + '%';
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  // ---------- Marquee duplicator (seamless loop) ----------
  function initMarquee() {
    const tracks = document.querySelectorAll('[data-marquee-track]');
    tracks.forEach(track => {
      if (track.dataset.duplicated === '1') return;
      const html = track.innerHTML;
      track.innerHTML = html + html;
      track.dataset.duplicated = '1';
    });
  }

  // ---------- Floating-label form ----------
  function initFloatingLabels() {
    const fields = document.querySelectorAll('.cf-fld select');
    fields.forEach(sel => {
      const sync = () => sel.classList.toggle('has-value', !!sel.value);
      sync();
      sel.addEventListener('change', sync);
    });
  }

  // ---------- Contact form (AJAX submit with success message) ----------
  function initContactForm() {
    const forms = document.querySelectorAll('[data-contact-form]');
    forms.forEach(form => {
      form.addEventListener('submit', (e) => {
        // Native Shopify form_action redirects on success — soft override:
        const success = form.querySelector('[data-cf-success]');
        const btn = form.querySelector('button[type="submit"]');
        if (btn) btn.setAttribute('disabled', 'true');
        // Let Shopify post to /contact normally; on POST it reloads with ?contact_posted=true
      });
    });
    // Show success on contact_posted
    if (location.search.indexOf('contact_posted=true') > -1) {
      const successes = document.querySelectorAll('[data-cf-success]');
      successes.forEach(s => {
        s.classList.add('visible');
        s.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  // ---------- Wishlist toggle (local-only) ----------
  function initWishlist() {
    const btns = document.querySelectorAll('[data-wishlist-toggle], [data-wishlist]');
    btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        btn.classList.toggle('active');
        // Persist in localStorage
        try {
          const handle = btn.dataset.productHandle;
          if (!handle) return;
          const key = 'capri_wishlist';
          const list = JSON.parse(localStorage.getItem(key) || '[]');
          if (btn.classList.contains('active')) {
            if (!list.includes(handle)) list.push(handle);
          } else {
            const idx = list.indexOf(handle);
            if (idx > -1) list.splice(idx, 1);
          }
          localStorage.setItem(key, JSON.stringify(list));
        } catch (err) { /* ignore */ }
      });
    });
    // Restore state on load
    try {
      const list = JSON.parse(localStorage.getItem('capri_wishlist') || '[]');
      btns.forEach(btn => {
        const h = btn.dataset.productHandle;
        if (h && list.includes(h)) btn.classList.add('active');
      });
    } catch (err) { /* ignore */ }
  }

  // ---------- Floating particles renderer ----------
  function initFloatingParticles() {
    const containers = document.querySelectorAll('[data-float-particles]');
    containers.forEach(c => {
      if (c.dataset.rendered === '1') return;
      const count = parseInt(c.dataset.floatParticles, 10) || 10;
      let html = '';
      for (let i = 0; i < count; i++) {
        const left = Math.random() * 100;
        const delay = Math.random() * 14;
        const dur = 12 + Math.random() * 10;
        const size = (Math.random() * 2 + 1).toFixed(1);
        const opa = (Math.random() * 0.4 + 0.3).toFixed(2);
        html += '<span style="left:' + left + '%; animation-delay:-' + delay.toFixed(1) + 's; animation-duration:' + dur.toFixed(1) + 's; width:' + size + 'px; height:' + size + 'px; --opa:' + opa + ';"></span>';
      }
      c.innerHTML = html;
      c.dataset.rendered = '1';
    });
  }

  // ---------- Init ----------
  function init() {
    initMobileMenu();
    initCountdowns();
    initAnnouncementBar();
    initWordReveal();
    initReveal();
    initParallax();
    initKenBurns();
    initHeroCanvas();
    initCartForms();
    initVariantPickers();
    initCartDrawer();
    initScrollProgress();
    initMarquee();
    initFloatingLabels();
    initContactForm();
    initWishlist();
    initFloatingParticles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
